export const FIELD_BACKGROUND_COLOR = {
  LIGHT: 'light',
  DARK: 'dark',
}
